var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0384 0H0V40.0387C0 62.1511 17.9258 80.0772 40.0384 80.0772C62.1511 80.0772 80.0769 62.1514 80.0769 40.0387C80.0769 17.9261 62.1511 0 40.0384 0Z",
    fill: "#DD4741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0387 4.44824H4.44922V40.038C4.44922 59.6936 20.3834 75.6278 40.039 75.6278C59.6946 75.6278 75.6288 59.6936 75.6288 40.038C75.6288 20.3824 59.6946 4.44824 40.0387 4.44824Z",
    fill: "#EC797C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.0387 4.44824H4.44922V40.038C4.44922 59.6936 20.3834 75.6278 40.039 75.6278C59.6946 75.6278 75.6288 59.6936 75.6288 40.038C75.6288 20.3824 59.6946 4.44824 40.0387 4.44824Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5116 54.8213H18.4229V62.91H26.5116V54.8213Z",
    fill: "#911004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6444 54.8213H30.5557V62.91H38.6444V54.8213Z",
    fill: "#911004"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7772 54.8213H42.6885V62.91H50.7772V54.8213Z",
    fill: "#911004"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5116 42.6885H18.4229V50.7772H26.5116V42.6885Z",
    fill: "#911004"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6444 42.6885H30.5557V50.7772H38.6444V42.6885Z",
    fill: "#911004"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5116 30.5557H18.4229V38.6444H26.5116V30.5557Z",
    fill: "#911004"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8212 18.4229H50.7771H46.7328H42.6887H42.6884H38.6444H30.5556H26.5116H18.4229V26.511V26.5113H26.5116V26.511H30.5556V26.5113V30.5556V38.6444H38.6444H42.6884H42.6887V42.6884H42.6884V50.7771H42.6887H50.7771H54.8212H54.8215V54.8215H54.8212V62.9099H54.8215H62.9099H62.9102V50.7771V46.7328V38.6444V34.6V18.4229H62.9099H54.8212Z",
    fill: "#911004"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8837 54.1934H17.7949V62.2821H25.8837V54.1934Z",
    fill: "#D1DA5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0165 54.1934H29.9277V62.2821H38.0165V54.1934Z",
    fill: "#D1DA5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1493 54.1934H42.0605V62.2821H50.1493V54.1934Z",
    fill: "#D1DA5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8837 42.0605H17.7949V50.1493H25.8837V42.0605Z",
    fill: "#D1DA5B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0165 42.0605H29.9277V50.1493H38.0165V42.0605Z",
    fill: "#D1DA5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8837 29.9277H17.7949V38.0165H25.8837V29.9277Z",
    fill: "#D1DA5B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.282 17.7949H54.1933H50.1492H46.1049H42.0608H42.0605H38.0164H29.9277H25.8837H17.7949V25.883V25.8834H25.8837V25.883H29.9277V25.8834V29.9277V38.0164H38.0164H42.0605H42.0608V42.0605H42.0605V50.1492H42.0608H50.1492H54.1933H54.1936V54.1936H54.1933V62.282H54.1936H62.282H62.2823V50.1492V46.1048V38.0164V33.9721V17.7949H62.282Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.0388,
    y1: 4.44834,
    x2: 40.0388,
    y2: 75.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0F00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesIcon1);
export default __webpack_public_path__ + "static/media/advantages_icon_1.bfc80d4efeeeaf6228df18d8aa86f480.svg";
export { ForwardRef as ReactComponent };